import { api, headers } from "./api";

const RESOURCE = 'nilai';

export const getTranskrip = (nim) => api.get(RESOURCE+'?nim='+nim, headers);

export const getKhs = (tahun) => api.get(RESOURCE+'/'+tahun, headers);
